module.exports = __webpack_public_path__ + "static/media/MoveIcon.3dedf5b5.svg";